<script>
import axios from "axios";
import API from "@/services/API.js";
import Button2 from "@/components/ui/Button2.vue";
import ChannelForm from "./ChannelForm.vue";
import ProfileIcon from "@/components/profiles/ProfileIcon.vue";

export default {
  name: "ChannelEdit",
  components: {
    Button2,
    ChannelForm,
    ProfileIcon
  },
  props: {
    channelId: {
      type: Number,
    },
  },
  data() {
    return {
      channel: null,
      isEditSubmitted: false,
      isDeleteSubmitted: false,
    };
  },
  methods: {
    loadChannel: function (channelId) {
      axios
        .get(API.route(API.endpoints.channels.show, { channelId: channelId }))
        .then((response) => {
          if (response.data) {
            this.channel = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSaveChannel: function (channelId, channel) {
      this.isEditSubmitted = true;
      axios
        .put(
          API.route(API.endpoints.channels.edit, { channelId: channelId }),
          channel
        )
        .then(({data}) => {
          if (data) {
            this.$emit("onSave", data);
          }
        })
        .catch((error) => {
          console.error("🐝", error);
          this.isEditSubmitted = false;
        });
    },
    handleDeleteChannel: function (channelId) {
      this.isDeleteSubmitted = true;
      axios
        .delete(
          API.route(API.endpoints.channels.delete, { channelId: channelId })
        )
        .then((response) => {
          if (response.data) {
            this.$emit("onDelete", channelId);
          }
        })
        .catch((error) => {
          console.error("🐝", error);
          this.isDeleteSubmitted = false;
        });
    },
  },
  created: function () {
    this.loadChannel(this.channelId);
  },
};
</script>

<template>
  <div>
    <div v-if="!channel">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">{{ $t("global.loading") }}</span>
      </div>
    </div>
    <div v-else>
      <div
        v-if="channel.profiles && channel.profiles.length"
        class="alert alert-warning mb-4"
        role="alert"
      >
        <div>
          {{ $t("watchmen.channels.warn_edit_with_profiles") }}
        </div>
        <ul class="m-0 mt-1 list-unstyled d-flex flex-column" style="gap: 4px">
          <li v-for="profile in channel.profiles" :key="profile.id">
            <router-link
              :to="`/configurations/profiles/${profile.id}`"
              class="d-flex align-items-center"
            >
              <ProfileIcon :icon="profile.icon" class="mr-2" />
              <span class="text-truncate">{{ profile.name }}</span>
            </router-link>
          </li>
        </ul>
      </div>

      <ChannelForm v-model="channel" class="mb-4" />
      <div
        class="d-flex pt-3"
        style="gap: 1rem; justify-content: flex-end; margin-bottom: -1rem"
      >
        <Button2
          @click.native.prevent="handleDeleteChannel(channelId)"
          class="btn-danger"
          :disabled="channel.profiles && !!channel.profiles.length || isEditSubmitted || isDeleteSubmitted"
        >
          <span
            v-if="isDeleteSubmitted"
            class="spinner-border spinner-border-sm ml-2"
            role="status"
            :aria-label="$t('global.loading')"
          ></span>
          {{ $t("global.delete") }}
        </Button2>
        <Button2
          @click.native.prevent="handleSaveChannel(channelId, channel)"
          :disabled="!channel.value || isEditSubmitted || isDeleteSubmitted"
        >
          <span
            v-if="isEditSubmitted"
            class="spinner-border spinner-border-sm ml-2"
            role="status"
            :aria-label="$t('global.loading')"
          ></span>
          {{ $t("global.save") }}
        </Button2>
      </div>
    </div>
  </div>
</template>
